import React, { Component } from 'react';
import {Switch, Link, Route} from 'react-router-dom'
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AddNewContainer from '../Components/AddNew/AddNewContainer';
import EditNewContainer from '../Components/AddNew/EditNewContainer';

class AddNewContainerMain extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));
        
        
        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }
        
    }
    
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <Switch>
                        <Route exact path="/notices" render={(props) => 
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="Notification"
                                code="notice"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/award" render={(props) =>
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="Award"
                                code="award"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        

                        <Route exact path="/events" render={(props) =>
                            <AddNewContainer
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />

                        <Route exact path="/edit" render={(props) =>
                            <EditNewContainer
                                {...props}
                                history={this.props.history}
                                title="Events"
                                code="events"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />
                    </Switch>

                   

                </div>
            </div>
        )
    }
}

export default withAuth(AddNewContainerMain);


// WEBPACK FOOTER //
// ./src/Containers/AddNewContainerMain.js